import React, { useState } from "react";
import "../../Styles/testimonial.css";
import { MdOutlineStar } from "react-icons/md";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none" }}
      onClick={onClick}
    />
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none" }}
      onClick={onClick}
    />
  );
};

function Testimonial({ testimonial }) {
  const [name, setName] = useState("");
  const [mainTitle, setMainTitle] = useState("")
  const [title, setTitle] = useState("");
  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState("")

  const settings = {
    className: "center",
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true,
    infinite: true,
    centerPadding: "80px",
    slidesToShow: 3,
    speed: 500,
    dots: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    afterChange: (current) => {
      if (testimonial && testimonial[current]) {
        setName(testimonial[current].name);
        setTitle(testimonial[current].location);
        setRating(testimonial[current].rating);
        setMainTitle(testimonial[current].title)
        setDescription(testimonial[current].description)
      }
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 536,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };
  return (
    <>
      <div className="container testimonail_main">
        <div className="testimonial_header_main">
          <h2>Testimonials</h2>
          <p>
            {mainTitle}{" "}
          </p>
          <img src="/images/quotes_image.png" alt="image" />
          <h6 dangerouslySetInnerHTML={{ __html: description }}>

          </h6>
        </div>

        <div className="testimonial_client_info">
          <h2>{name}</h2>
          <p>{title}</p>
          <div className="d-flex align-items-center justify-content-center">
            {[...Array(5)].map((_, index) => (
              <MdOutlineStar
                key={index}
                style={{ color: index < rating ? "gold" : "grey" }}
              />
            ))}
          </div>
          <div className="my-5 testimonial_slider">
            <Slider {...settings}>
              {testimonial &&
                testimonial?.map((item, i) => {
                  return (
                    <div className="slider_wrapper">
                      <img src={item.image || "/images/user5.png"} alt="img" />
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
}

export default Testimonial;
